export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const URL_VALIDATION_PATTERN = '^https?://.+';

export const ONLY_DIGITS_VALIDATION_PATTERN = '[0-9]+';
